import { render } from "./todoBtn.vue?vue&type=template&id=451b5400&scoped=true"
import script from "./todoBtn.vue?vue&type=script&lang=js"
export * from "./todoBtn.vue?vue&type=script&lang=js"

import "./todoBtn.vue?vue&type=style&index=0&id=451b5400&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-451b5400"

export default script